import Chat from '@/components/Icons/SelfServe/Chat'
import { Sku, SkuPriceOptionsResponse } from '@/types/interfaces/sku'
import { VisitOptionCard } from '@/components/VisitOptions/VisitOptionCard'

interface ChatVisitOptionProps {
    sku: Sku
    prices: SkuPriceOptionsResponse | null
    userHomeTimezone?: string | null
    availability?: string | null
    availabilityLoading?: boolean
    theme?: 'default' | 'tight'
    onClick?: () => void
}

export const ChatVisitOption = ({
    sku,
    prices,
    userHomeTimezone,
    availability,
    availabilityLoading,
    theme = 'default',
    onClick,
}: ChatVisitOptionProps) => {
    const priceMapping = prices?.sku_price_mapping?.find((mapping) => String(mapping.id) === String(sku.id))
    const rawPrices = priceMapping?.prices
    const pricesArray = Array.isArray(rawPrices) ? rawPrices : rawPrices ? [rawPrices] : []
    // Flatten all options arrays from each SkuPricesResponse in pricesArray
    const allOptions = pricesArray.flatMap((price) => price.options || []) ?? []
    // Find the SkuPriceOption where type === 'chat'
    const chatPriceOption = allOptions.find((opt) => opt.type === 'chat')

    const cashPrice = chatPriceOption?.cash != null ? `$${chatPriceOption.cash / 100}` : '$35'

    return (
        <VisitOptionCard
            key="chat"
            icon={<Chat size={20} />}
            title="Chat"
            price={cashPrice ?? ''}
            insuranceText={theme === 'tight' ? 'w/o insurance' : 'Without insurance'}
            skuId={sku.id}
            optionType="chat"
            userHomeTimezone={userHomeTimezone}
            availability={availability}
            availabilityLoading={availabilityLoading}
            theme={theme}
            onClick={onClick}
        />
    )
}
